<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">List Scraping</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">List Scraping</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <router-link
                  :to="'/monitoring/scrape/wizard'"
                  :class="'btn add-btn'"
                >
                  <i class="la la-cloud-download"></i> Scrape
                </router-link>
              </div>
            </div>
          </div>
          <!-- {{formParamSt}} -->
          <!-- /Page Header -->
          <!-- {{serverParams}} -->
          <!-- Search Filter -->
          <!-- {{selectAllTable}}-->
          <!-- {{selectedTable}} -->
          <div class="row filter-row" v-if="!selectedTable.length">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <!-- <div class="cal-icon"> -->
                <input
                  v-model="serverParams.columnFilters.start_date"
                  class="form-control floating"
                  type="date"
                />
                <!-- </div> -->
                <label class="focus-label sr-only">From</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <div class="input-group">
                  <!-- <div class="cal-icon"> -->
                  <input
                    v-model="serverParams.columnFilters.end_date"
                    class="form-control floating"
                    type="date"
                  />
                  <!-- </div> -->
                  <div class="input-group-append">
                    <a
                      title="Show search options"
                      class="btn btn-primary"
                      @click="showSearchForm()"
                      href="#"
                      data-toggle="modal"
                      data-target="#search_form"
                    >
                      <i class="fa fa-list"></i>
                      <i
                        class="fa fa-circle"
                        v-if="formParamSt.more_search == true"
                      ></i>
                    </a>
                  </div>
                </div>

                <label class="focus-label sr-only">To</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <a
                  href="javascript:void(0)"
                  @click.prevent="searchData"
                  class="btn btn-success btn-block"
                  >Search</a
                >
              </div>
            </div>
          </div>
          <div class="row filter-row" v-if="selectedTable.length">
            <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button
                  :disabled="isLoading"
                  @click.prevent="actionUpdateStatus('unpublish')"
                  class="btn btn-primary btn-block"
                >
                  <i class="la la-pause"></i> Unpublish
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button
                  :disabled="isLoading"
                  @click.prevent="actionUpdateStatus('publish')"
                  class="btn btn-success btn-block"
                >
                  <i class="la la-check"></i> Publish
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button
                  :disabled="isLoading"
                  @click.prevent="actionDelete"
                  class="btn btn-danger btn-block"
                >
                  <i class="la la-trash"></i> Delete
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="text-right">
                <!-- <button class="btn btn-success btn-block">Scrape</button>-->
                <a @click.prevent="hideActions" class="btn btn-xs">
                  <i class="fa fa-close"></i> Close
                </a>
              </div>
            </div>
          </div>

          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <!-- {{currentDateTimeUnix()}} -->
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th>
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="selectAllTable" />
                          </label>
                        </div>
                      </th>
                      <th class="text-center">Title</th>
                      <th class="text-center">Brand &amp; Product</th>
                      <th class="text-center">Marketplace</th>
                      <th class="text-center">Keywords</th>
                      <th class="text-center">Range Harga</th>
                      <th class="text-center">Status</th>
                      <th class="text-center">Recurring</th>
                      <th class="text-center">Last Modified</th>
                      <th class="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="9">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <td>
                          <div class="checkbox">
                            <label>
                              <!-- <input type="checkbox" name="checkbox" /> -->
                              <input
                                type="checkbox"
                                v-model="selectedTable"
                                :value="row.id"
                              />
                            </label>
                          </div>
                        </td>
                        <td class="text-left">
                           <router-link
                            :to="
                              '/monitoring/links/list?scraping_schedule_id=' + row.id
                            "
                            >{{ row.title }}</router-link>
                        </td>
                        <td class="text-wrap">
                          <div class="text-muted" :ref="'brand-' + row.id">
                            <Skeleton :count="1" />
                          </div>
                          <div
                            class="text text-dark"
                            :ref="'product-' + row.id"
                          >
                            <Skeleton :count="1" />
                          </div>
                        </td>
                        <td class="text-wrap" :ref="'marketplace-' + row.id">
                          <Skeleton :count="1" />
                        </td>
                        <td class="text-wrap" :ref="'keywords-' + row.id">
                          <Skeleton :count="1" />
                        </td>
                        <td class="text-left">
                          <span>{{ formatPrice(row.min_price) }}</span>
                          <span>- {{ formatPrice(row.max_price) }}</span>
                          <div class="text-muted">
                            {{
                              marketplaceLabelFilter(row.sort_by, row.order_by)
                            }}
                          </div>
                        </td>
                        <td class="text-wrap">
                          <template v-if="row.is_publish == 0">
                            <span :class="'text text-warning'">
                              <i class="fa fa-pause"></i>
                              DRAFT
                            </span>
                          </template>
                          <template v-if="row.is_publish == 1">
                            <span
                              :class="'text text-success'"
                              v-if="row.sending_options == 1"
                            >
                              <i class="fa fa-check"></i>
                              SENT
                              <br />
                              <small v-if="row.cron_timestamp > 0">{{
                                timeAgo(row.cron_timestamp)
                              }}</small>
                              <small v-else>
                                {{ timeAgo(row.update_datetime) }}
                                <br />(send now)
                              </small>
                            </span>
                            <span
                              :class="'text text-success'"
                              v-if="
                                row.sending_options == 2 &&
                                  row.sending_schedule < currentDateTimeUnix()
                              "
                            >
                              <i class="fa fa-check"></i>
                              Sent
                              <br />
                              <small v-if="row.cron_timestamp > 0">{{
                                timeAgo(row.cron_timestamp)
                              }}</small>
                            </span>
                            <span
                              :class="'text text-info'"
                              v-if="
                                row.sending_options == 2 &&
                                  row.sending_schedule > currentDateTimeUnix()
                              "
                            >
                              <i class="fa fa-clock-o"></i>
                              Scheduled
                              <br />
                              <small>{{
                                formatLocalDateWithDay(row.sending_schedule)
                              }}</small>
                            </span>
                          </template>
                        </td>
                        <td class="text-wrap">
                          <template v-if="row.is_recurring == 1">
                            <i class="fa fa-clock-o"></i>
                            {{ row.recurrence }}
                            <span>
                              <br />
                              time:
                              {{
                                formatHourFromUnix(
                                  convertUTCDatetimeToUnix(row.recurrence_time)
                                )
                              }}
                            </span>
                            <span v-if="row.recurrence != 'daily'">
                              <br />
                              every: {{ row.recurrence_every }}
                              {{ row.recurrence_annually_month }}
                            </span>

                            <br />end:
                            <span v-if="row.recurrence_end == 'never'">{{
                              row.recurrence_end
                            }}</span>
                            <span v-else>{{
                              formatLocalDate(row.recurrence_end_date)
                            }}</span>
                          </template>
                          <template v-else>-</template>
                        </td>

                        <td class="text-wrap">
                          {{ formatLocalDate(row.update_datetime) }}
                        </td>
                        <td class="text-center">
                          <router-link
                            title="Edit"
                            :to="'wizard?id=' + row.id"
                            class="badge badge-primary"
                            ><i class="la la-pencil"></i
                          ></router-link>
                          <router-link
                            title="Copy"
                            :to="'wizard?id=' + row.id + '&copy=1'"
                            class="badge badge-primary"
                            ><i class="la la-copy"></i
                          ></router-link>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="9" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select
                @change="onPerPageChange(serverParams.perPage)"
                autocomplete="off"
                name="perPageSelect"
                v-model="serverParams.perPage"
                style="width: 100px;"
                class="select-to-paginasi"
              >
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label"
                >of {{ totalRecords }} total records</span
              >
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a
                href="javascript:void(0)"
                @click="onPrevChange(parseInt(currentPage))"
                tabindex="0"
                class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
              >
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input
                style="width:100px;"
                min="1"
                type="number"
                v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))"
                class
              />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a
                href="javascript:void(0)"
                @click="onNextChange(parseInt(currentPage))"
                tabindex="0"
                class="footer__navigation__page-btn"
                :class="
                  'btn ' +
                    {
                      disabled:
                        parseInt(currentPage) + 1 >
                        Math.ceil(totalRecords / serverParams.perPage)
                    }
                "
              >
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <form-data :searchData="searchDataMore" />

    <!-- {{selectedContact}} -->
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import {
  getFirstLastDayInWeek,
  formatDateForMessage,
  formatPrice,
  formatLocalDate,
  marketplaceIcon,
  monitoringStatusLabelStyle,
  monitoringStatusLabel,
  timeAgo,
  marketplaceLabelFilter,
  formatLocalDateWithDay,
  formatHourFromUnix,
  convertUTCDatetimeToUnix,
  currentDateTimeUnix
} from "@/utils/helper";
import FormData from "./form.vue";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    FormData
  },
  data() {
    return {
      linkExcel: "",
      selectedTable: [],
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          start_date: "",
          end_date: "",
          mp_product_master_id: "",
          brand_id: "",
          min_price: "",
          max_price: "",
          is_publish: "",
          is_running: ""
        },
        page: 1,
        perPage: 20, // perPage
        more_search: false
      }
    };
    //  isactive : true
  },
  computed: {
    formParamSt() {
      return this.$store.state.monitoring.formParamSt;
    },
    isShowForm() {
      return this.$store.state.monitoring.isShowForm;
    },
    selectAllTable: {
      get: function() {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function(value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function(row) {
            selectedTable.push(row.id);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },
  watch: {},
  created() {
    this.getFirstLastDayInWeek();
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    currentDateTimeUnix() {
      return currentDateTimeUnix();
    },
    convertUTCDatetimeToUnix(utcDatetime) {
      return convertUTCDatetimeToUnix(utcDatetime);
    },
    formatHourFromUnix(utcdttz) {
      return formatHourFromUnix(utcdttz);
    },
    formatLocalDateWithDay(value) {
      return formatLocalDateWithDay(value);
    },
    marketplaceLabelFilter(sortBy, orderBy) {
      return marketplaceLabelFilter(sortBy, orderBy);
    },
    timeAgo(unixTime) {
      return timeAgo(unixTime);
    },

    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },
    actionUpdateStatus(statusValue) {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to update status " +
          this.selectedTable.length +
          " items to " +
          statusValue +
          "?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              action: "update_status",
              status: statusValue
            };
            this.$store
              .dispatch("monitoring/scrapingActionStored", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Update",
                  text: "The data was successfully updated",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;
                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    actionDelete() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase " +
          this.selectedTable.length +
          " items?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              action: "delete"
            };
            this.$store
              .dispatch("monitoring/scrapingActionStored", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Delete",
                  text: "The data was successfully deleted",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;
                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    monitoringStatusLabel(status) {
      return monitoringStatusLabel(status);
    },
    monitoringStatusLabelStyle(status) {
      return monitoringStatusLabelStyle(status);
    },
    formatDateForMessage(utcDateTime, format) {
      return formatDateForMessage(utcDateTime, format);
    },
    getFirstLastDayInWeek() {
      // let days = getFirstLastDayInWeek();
      // this.serverParams.columnFilters.start_date = this.formatDateForMessage(
      //   days.firstday,
      //   "ISODate"
      // );
      // this.serverParams.columnFilters.end_date = this.formatDateForMessage(
      //   days.lastday,
      //   "ISODate"
      // );
    },
    showSearchForm() {
      this.$store.dispatch("monitoring/setIsShowForm", false);
      this.$store.dispatch("monitoring/actFormParamSt", this.serverParams);
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("search_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("monitoring/setIsShowForm", true);
        }
      }, 1000);
    },

    marketplaceIcon(value) {
      return marketplaceIcon(value);
    },
    formatLocalDate(unixTime) {
      return formatLocalDate(unixTime);
    },
    formatPrice(number) {
      return formatPrice(number);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },

    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();
      this.linkExcel = "";
      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;

      await this.$store.dispatch(
        "monitoring/actFormParamListScrapingSt",
        this.serverParams
      );
    },
    async searchDataMore() {
      this.linkExcel = "";

      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();
      this.serverParams = this.formParamSt;
      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;

      // await this.$store.dispatch(
      //   "monitoring/actFormParamSt",
      //   this.serverParams
      // );
    },

    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);
      if (this.$route.query.scheduled) {
        this.serverParams.columnFilters.is_publish = "running";
        this.serverParams.columnFilters.is_running = "all";
        this.serverParams.more_search = true;
        this.$store.dispatch("monitoring/actFormParamSt", this.serverParams);
        this.searchDataMore();
        this.$router.replace({ query: null });
        return 0;
      }
      await this.$store
        .dispatch("monitoring/listScraping", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;

          if (this.rows.length) {
            this.rows.forEach((row, idx) => {
              let detailId = row.brand_id;
              this.$store
                .dispatch("brand/detail", detailId) // sesuai kan dengan method di API
                .then(responseDet => {
                  var resData = responseDet.data;
                  this.$refs["brand-" + row.id][0].innerHTML = resData.name;
                });
              let prodId = row.mp_product_master_id;

              this.$store
                .dispatch("brandProduct/detail", prodId) // sesuai kan dengan method di API
                .then(responseDet => {
                  var resData = responseDet.data;
                  this.$refs["product-" + row.id][0].innerHTML = resData.name;
                });

              let scheduleId = row.id;
              this.$store
                .dispatch("monitoring/getMarketplaceByScheduleId", scheduleId) // sesuai kan dengan method di API
                .then(responseDet => {
                  var resData = responseDet.data;

                  resData.forEach((rowMarketplace, idxMarketplace) => {
                    if (idxMarketplace == 0) {
                      this.$refs[
                        "marketplace-" + scheduleId
                      ][0].innerHTML = this.marketplaceIcon(
                        rowMarketplace.mp_master_id
                      );
                    } else {
                      this.$refs[
                        "marketplace-" + scheduleId
                      ][0].innerHTML += this.marketplaceIcon(
                        rowMarketplace.mp_master_id
                      );
                    }
                  });
                });
              this.$store
                .dispatch("monitoring/getKeywordsByScheduleId", scheduleId) // sesuai kan dengan method di API
                .then(responseDet => {
                  var resData = responseDet.data;
                  resData.forEach((rowKeywords, idxKeywords) => {
                    if (idxKeywords == 0) {
                      this.$refs["keywords-" + scheduleId][0].innerHTML =
                        rowKeywords.name;
                    } else {
                      this.$refs["keywords-" + scheduleId][0].innerHTML +=
                        ", " + rowKeywords.name;
                    }
                  });
                });
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-list"
};
</script>



// WEBPACK FOOTER //
// src/views/monitoring/scrape/list.vue